import moment from 'moment';
const defaultTimestampFormat = 'D MMM YYYY, HH:mm:ss Z';
// Returns a formatted date string using moment's date formatting capabilities
export const formattedTimestamp = (date, format = defaultTimestampFormat) => {
    // An undefined date is unknown
    if (date === undefined)
        return '-';
    // A null date is interpreted as 'now' and can be parsed normally
    const dateAsMoment = moment(date);
    return dateAsMoment.format(format);
};
